import React from 'react';

import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import { notFoundPath, routes as configRoutes } from '@navigation/routes';
import { generateAppRoutes, Router } from '@navigation';
import { getEnv } from '@config';
import persist from '@store/store';
import theme from '@styles/theme';

const { persistor, store } = persist();
const { publicPath } = getEnv();

const App = ({ location }) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider theme={theme}>
        <Router
          routes={generateAppRoutes(configRoutes)}
          notFoundPath={notFoundPath}
          publicPath={publicPath}
          location={location}
        />
      </ThemeProvider>
    </PersistGate>
  </Provider>
);

export default App;
